module.exports = __webpack_public_path__ + "aj.no2.d4a9edf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/aj.no2.jpg
// module id = k3/z
// module chunks = 0